import { graphql } from "gatsby"
import React from "react"
import Layout from "../components/layout"
import Main from "../modules/Main"
import Seo from "../components/Seo/Seo"

const Page = props => {
  const post = props.data.post
  const { location } = props

  return (
    <div className={`fullPageanimation `}>
      <Layout props={props}>
        <Main modules={post.pageContent} location={location} />
      </Layout>
    </div>
  )
}

export default Page
export const pageQuery = graphql/* GraphQL */ `
  query PageById($id: String!) {
    post: wpPage(id: { eq: $id }) {
      id
      title
      ...MainFragment
      ...seoPageFragment
    }
  }
`
export const Head = ({ data }) => {
  const post = data.post
  return <Seo seo={post.seo} />
}